// extracted by mini-css-extract-plugin
module.exports = {"skeletonDraggableUploadFileStub":"SkeletonUploadFileStub_skeletonDraggableUploadFileStub__3AHBf","dashedContainer":"SkeletonUploadFileStub_dashedContainer__3AlG3"};